export default __webpack_public_path__ + "static/media/oly_banner.074f2640.png";